import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  LinearProgress,
  Divider,
} from "@mui/material";
import { CalendarToday, LocationOn, Description } from "@mui/icons-material";

const DeploymentWidget = ({
  projectId = "P-012345",
  projectName = "Project Name",
  clientName = "[Client Name]",
  startDate = "Jan 1, 2024",
  endDate = "Jan 24, 2024",
  address = "19200 Von Karman Ave, Irvine, CA 92612",
  role = "Role",
  rate = "$100.00 /hr",
  laborId = "CLIN 01.1, [Task Description]",
  teId = "CLIN 01.2, Travel and Expenses",
  hoursLeft = 200,
  totalHours = 1600,
  style,
}) => {
  const progressValue = ((totalHours - hoursLeft) / totalHours) * 100;

  return (
    <Card
      sx={{
        maxWidth: 400,
        borderRadius: 2,
     
        overflow: "hidden",
        ...style,
        display: "flex", 
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          bgcolor: "#005230",
          color: "white",
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            bgcolor: "rgba(255,255,255,0.2)",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            fontWeight: 600,
          }}
        >
          {projectId}
        </Typography>
        <Button
          startIcon={<Description />}
          sx={{
            color: "white",
            textTransform: "none",
            fontWeight: 500,
          }}
        >
          View Deployment Note
        </Button>
      </Box>

      <CardContent sx={{ p: 3 }}>
        {/* Project Details */}
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{ mb: 1, color: "black" }}
          >
            {projectName}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Client: {clientName}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <CalendarToday sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography variant="body2" color="text.secondary">
              {startDate} - {endDate}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <LocationOn
              sx={{ fontSize: 16, color: "text.secondary", mt: 0.2 }}
            />
            <Typography variant="body2" color="text.secondary">
              {address}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Project Details Grid */}
        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 2 }}>
          <Box>
            <Typography variant="body2" fontWeight={600} color="text.primary">
              Role
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {role}
            </Typography>
          </Box>

          <Box>
            <Typography variant="body2" fontWeight={600} color="text.primary">
              Rate
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {rate}
            </Typography>
          </Box>

          <Box>
            <Typography variant="body2" fontWeight={600} color="text.primary">
              Labor ID
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {laborId}
            </Typography>
          </Box>

          <Box>
            <Typography variant="body2" fontWeight={600} color="text.primary">
              T&E ID
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {teId}
            </Typography>
          </Box>
        </Box>

        {/* Hours Progress */}
        <Box sx={{ mt: 3 }}>
          <Box sx={{width:"70%", display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="body2" fontWeight={600} sx={{ minWidth: "40px" }}>
              Hours
            </Typography>
            <LinearProgress
              variant="determinate"
              value={progressValue}
              sx={{
                width:"40%",
                height: 4,
                borderRadius: 4,
                bgcolor: "#E0E0E0",
                "& .MuiLinearProgress-bar": {
                  bgcolor: "#2E7D32",
                  borderRadius: 4,
                },
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{  width:"fit-content" }}>
              {hoursLeft} Left / {totalHours} Budgeted
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DeploymentWidget;
